
<form id="freeTextSearch" class="ui form" @submit.prevent="search()">
  <div class="ui icon input">
    <input type="text" v-model="model.q" placeholder="お店を検索">
    <i class="search icon"></i>
  </div>
</form>
